module.exports = "/_next/static/images/slide-2-d93915d0fd88f094889d87100f2ef3a7.png";